export default "__VITE_ASSET__DbXNgoQG__"